import React from 'react'
import { connect } from "react-redux";

const NAV = {
    DAILY:'daily',
    DAYS:'days'
}
const Nav = props => {
    return (
        <div className="nav">
            <div
                className="sections"
                style={{
                    background: "white"
                }}
                onClick={props.switch}
            ><i className={`fa fa-${props.view === 'list' ? 'line-chart' : 'list'} fa-2x`} aria-hidden="true"></i></div>
            <div
                className="sections"
                style={{
                    background: props.nav === 'daily' ? "orange" : 'white'
                }}
                onClick={props[NAV.DAILY]}
            >24 hours</div>
            <div
                className="sections"
                style={{
                    background: props.nav === 'days' ? "orange" : 'white'
                }}
                onClick={props[NAV.DAYS]}
            >30 days</div>
        </div>
    )
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        SET_METHOD: () => dispatch({ type: 'SET_METHOD' }),
    };
}

export default connect(null,mapDispatchToProps)(Nav)


// WEBPACK FOOTER //
// ./src/ui/item/nav.js